'use client';
import React, { useState } from "react";

const PDFDownload: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    setLoading(true);
    
    try {
      // Using the correct path from the public folder
      const pdfPath = "/CFS e-catlouge.pdf"; // Place the PDF in the public folder
      
      const link = document.createElement("a");
      link.href = pdfPath; // No need for ../components/images since it's in public
      link.download = "CFS e-catalogue.pdf"; // File name for download
      
      // Ensure the link is properly appended and clicked
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      
      // Reset loading state after download
      setTimeout(() => {
        setLoading(false);
      }, 500); // Reduced delay since actual download is quick
    } catch (error) {
      console.error("Download failed:", error);
      setLoading(false); // Reset loading even if there's an error
    }
  };

  return (
    <div className="download_btn">
      <button 
        onClick={handleDownload} 
        disabled={loading}
        className="!font-medium"
        aria-label={loading ? "Downloading in progress" : "Download E-Catalogue"}
      >
        {loading ? "Downloading..." : "Download the E-Catalogue"}
      </button>
    </div>
  );
};

export default PDFDownload;